module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "lottery-ssc"
  }, [_c('div', {
    staticClass: "top-bar"
  }, [_c('span', {
    staticClass: "btn-back left-arrow iconfont",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hide()
      }
    }
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "select-text"
  }, [_vm._v("玩法")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('span', {
    staticClass: "btn-select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showSelectBox($event)
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.selectText))]), _vm._v(" "), _c('span', {
    staticClass: "hhs-icon iconfont",
    class: {
      active: _vm.showSelect
    }
  }, [_vm._v("")])])]), _vm._v(" "), _c('span', {
    staticClass: "btn-history",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showHis()
      }
    }
  }, [_vm._v("历史记录")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSelect),
      expression: "showSelect"
    }],
    staticClass: "select-box"
  }, [_c('span', {
    staticClass: "select-item line",
    class: {
      active: _vm.selectType === 'pt'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectedType('pt')
      }
    }
  }, [_vm._v("普通投注"), _c('i', {
    staticClass: "iconfont icon"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', {
    staticClass: "select-item",
    class: {
      active: _vm.selectType === 'dt'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.selectedType('dt')
      }
    }
  }, [_vm._v("胆拖投注"), _c('i', {
    staticClass: "iconfont icon"
  }, [_vm._v("")])])])]), _vm._v(" "), _c('pt', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectType === 'pt'),
      expression: "selectType === 'pt'"
    }],
    ref: "pt",
    on: {
      "select": _vm.selectPt
    }
  }), _vm._v(" "), _c('dtlottery', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectType === 'dt'),
      expression: "selectType === 'dt'"
    }],
    ref: "dtlottery",
    on: {
      "select": _vm.selectDt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-bar"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showClear),
      expression: "!showClear"
    }],
    staticClass: "btn-random",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleChoice($event)
      }
    }
  }, [_vm._v("机选")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClear),
      expression: "showClear"
    }],
    staticClass: "btn-clear",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clear()
      }
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('div', {
    staticClass: "price-box"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.count > 0),
      expression: "count>0"
    }],
    staticClass: "price"
  }, [_vm._v("共" + _vm._s(_vm.count) + "注"), _c('i', [_vm._v(_vm._s(_vm.money) + "元")])])]), _vm._v(" "), _c('span', {
    staticClass: "btn-submit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sureCode($event)
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoice),
      expression: "showChoice"
    }],
    staticClass: "cpChoiceBei"
  }, [_c('div', {
    staticClass: "cpChoiceBeiItem border-1px",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.choice(1)
      }
    }
  }, [_c('span', {
    staticClass: "cpChoiceIcon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/bei1.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cpChoiceText"
  }, [_vm._v("1注")])]), _vm._v(" "), _c('div', {
    staticClass: "cpChoiceBeiItem border-1px",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.choice(5)
      }
    }
  }, [_c('span', {
    staticClass: "cpChoiceIcon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/bei2.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cpChoiceText"
  }, [_vm._v("5注")])]), _vm._v(" "), _c('div', {
    staticClass: "cpChoiceBeiItem border-1px",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.choice(10)
      }
    }
  }, [_c('span', {
    staticClass: "cpChoiceIcon"
  }, [_c('img', {
    attrs: {
      "src": require("./images/bei3.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cpChoiceText"
  }, [_vm._v("10注")])])])]), _vm._v(" "), _c('tooltip', {
    ref: "tooltip",
    attrs: {
      "text": "请至少选择1注"
    }
  }), _vm._v(" "), _c('buy', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBuy && _vm.lotteryList.length > 0),
      expression: "showBuy && lotteryList.length > 0"
    }],
    ref: "buy",
    attrs: {
      "lottery-list": _vm.lotteryList
    },
    on: {
      "clear": _vm._initialize,
      "hide": _vm.hideBuy,
      "choice": _vm.choice,
      "remove": _vm.removeCp,
      "toggle": _vm.toggleCp
    }
  }), _vm._v(" "), _c('history', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHistory),
      expression: "showHistory"
    }],
    ref: "history",
    on: {
      "hide": _vm.hideHis
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a52f71d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssc/ssc.vue
// module id = 65
// module chunks = 0